import React, { useState } from 'react'
import './userlogin.scss'
import API_CONSTANTS from '../api-constants'
import { useHistory } from 'react-router-dom'

const ResetPasswordSuccess = () => {

   

    document.getElementsByTagName('body')[0].style.backgroundColor = 'black'
    
    return (
        
        <div className='login-profile' style={{marginTop:'-15px'} }> 
                   
            <p style={{fontSize:'36px'} }>Vi har sendt dig en email</p>
                    <p className='desc'>Tjek din email for at nulstille din adgangskode.  </p>
               </div> 
       
            )
}

export default ResetPasswordSuccess